/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { BudgetControllerService } from './services/budget-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    BudgetControllerService,
    ApiConfiguration
  ],
})
export class BillableServiceBudgetModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<BillableServiceBudgetModule> {
    return {
      ngModule: BillableServiceBudgetModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: BillableServiceBudgetModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('BillableServiceBudgetModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
